import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=e056e5da&scoped=true&lang=pug"
import script from "./FamilyList.vue?vue&type=script&lang=ts"
export * from "./FamilyList.vue?vue&type=script&lang=ts"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=e056e5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e056e5da",
  null
  
)

export default component.exports